function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
export var QcRejectionDialogController =
/*#__PURE__*/
function () {
  _createClass(QcRejectionDialogController, null, [{
    key: "$inject",
    get: function get() {
      return ['$mdDialog', '$scope', '$timeout'];
    }
  }]);

  function QcRejectionDialogController($mdDialog, $scope, $timeout) {
    _classCallCheck(this, QcRejectionDialogController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $mdDialog: $mdDialog,
      $scope: $scope,
      $timeout: $timeout
    });
    var vm = this;
    /* BINDABLE : DATA */

    vm.reasons = ['Video Quality', 'Audio Quality', 'Standards and Practices', 'Captioning', 'Metadata', 'Other'];
    vm.selectedReason = null;
    vm.rejectionLetter = null;
    /* EVENTS */
    //Register any event listeners
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(QcRejectionDialogController, [{
    key: "cancel",
    value: function cancel() {
      var vm = this;
      vm.$mdDialog.cancel();
    }
  }, {
    key: "reject",
    value: function reject() {
      var vm = this; // Call hide and pass back whether it was a success or not

      vm.$mdDialog.hide({
        reason: vm.selectedReason,
        notes: vm.rejectionLetter
      });
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {// Method-wide declarations
    }
  }]);

  return QcRejectionDialogController;
}();